/**
 * 用户购买服务的情况
 *
 * 说明：VIP 角标改为自包含的 inline SVG 皇冠徽章，不再依赖任何打包/远程图片，
 * 从根本上杜绝"图标 404 破图/丢失"问题；会员态金色高亮，非会员态置灰但依然可见。
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { statistic, StatisticCategory, isWechatMiniProgram, openH5InNewWebview } from 'util/index';
import styles from './VipInfo.module.scss';

interface Props {
    isVip: boolean;
    expireTime?: string;
}

// 自包含皇冠图标，颜色随 color 透传，永不破图
function CrownIcon({ color }: { color: string }) {
    return (
        <svg className={styles.crown} viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path
                fill={color}
                d="M3 7l4.5 3.5L12 4l4.5 6.5L21 7l-1.7 11H4.7L3 7zm2.2 13h13.6v1.5H5.2V20z"
            />
        </svg>
    );
}

export function VipInfo (props: Props) {
    const history = useHistory();
    function showPay() {
        if (isWechatMiniProgram()) {
          openH5InNewWebview({
            url: '/mp/user/pay',
            jumpMethod: 'navigateTo',
          });
        } else {
          history.push('/mp/user/pay');
        }
        statistic({
            category: StatisticCategory.UserCenter,
            action: '点击-VIP区域',
        });
    }

    // 仅展示会员状态徽章；开通/续费 CTA 由头像下方的 MemberCard 承载
    if (props.isVip) {
        return (
            <div onClick={showPay} className={styles.con}>
                <span className={`${styles.badge} ${styles.badgeVip}`}>
                    <CrownIcon color="#b8860b" />
                    VIP
                </span>
            </div>
        );
    }
    return (
        <div onClick={showPay} className={styles.con}>
            <span className={`${styles.badge} ${styles.badgeGray}`}>
                <CrownIcon color="#9a9a9a" />
                未开通
            </span>
        </div>
    );
}
